import { useEffect, useState } from "react";
import { fetchPurchaseRequisitions, downloadPurchaseRequisitionsExcel } from "../Api/ViewPurchaseRequisition";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewPurchaseRequisition = () => {
  const [purchaseRequisitions, setPurchaseRequisitions] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadPurchaseRequisitions = async () => {
      try {
        const data = await fetchPurchaseRequisitions();
        setPurchaseRequisitions(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Purchase Requisitions`);
      }
    };

    loadPurchaseRequisitions();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadPurchaseRequisitionsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Purchase_Requisitions_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Purchase requisitions data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Purchase Requisitions</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || purchaseRequisitions.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {purchaseRequisitions.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PR Type</th>
                    <th>Item Type</th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Unit</th>
                    <th>Requested Delivery Date</th>
                    <th>Requested For</th>
                    <th>Requested For Code</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Last Changed On</th>
                    <th>Last Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseRequisitions.map((pr, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{pr.pR_Type || 'N/A'}</td>
                      <td>{pr.purchase_Item_Type || 'N/A'}</td>
                      <td>{pr.item || 'N/A'}</td>
                      <td>{pr.quantity || 'N/A'}</td>
                      <td>{pr.unit || 'N/A'}</td>
                      <td>
                        {pr.requested_Delivery_Date ? 
                          moment(pr.requested_Delivery_Date).format('L') : 
                          'N/A'}
                      </td>
                      <td>{pr.requested_For || 'N/A'}</td>
                      <td>{pr.requested_For_Code || 'N/A'}</td>
                      <td>
                        {moment(pr.createdOnDate).format('L')} at {pr.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{pr.createdBy}</td>
                      <td>
                        {pr.changedOnDate ? 
                          `${moment(pr.changedOnDate).format('L')} at ${pr.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{pr.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No purchase requisitions found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewPurchaseRequisition;